import React from 'react';
import { BaseComponent } from './BaseComponent.js';
import { Header } from './Header.js';
import { LeftSidebar } from './LeftSidebar.js';

export class BaseTemplate extends BaseComponent {
  constructor(props) {
    super(props);

    this.toggleMenu = this.toggleMenu.bind(this);
    this.state = { classMenu: 'left-sidebar', menuOpen: false  };
  }

  toggleMenu() {
    if(this.state.menuOpen) {
      this.setState({ classMenu: 'left-sidebar', menuOpen: false });
    } else {
      this.setState({ classMenu: 'left-sidebar is-open', menuOpen: true });
    }
  }

  render() {
    return (
      <div className="app">
        <Header callbackToggleMenu={ this.toggleMenu } />
        <div className="app__container">
          <LeftSidebar classMenu={ this.state.classMenu } />
          <div className="main-content">
            { this.props.children }
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BaseTemplate.js